module.exports = __webpack_public_path__ + "static/wonder-7f55b32d5d70685abcbddaac303857c0.png";